import posthog from "../posthog";
import { apiGet, apiPost, apiPatch } from "../api";
async function safeJson(res) {
    const text = await res.text();
    try {
        return JSON.parse(text);
    }
    catch {
        return {};
    }
}
export async function getSession() {
    const data = await apiGet("/api/me");
    if (!data || typeof data !== "object" || !("user" in data))
        return null;
    return data;
}
// Deliberately NOT apiPost: a wrong password here is a normal 401 from better-auth, not a dead
// session — apiPost's shared 401 handling would redirect the login form itself to "/".
export async function signIn(email, password) {
    const res = await fetch("/api/auth/sign-in/email", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
    });
    if (!res.ok) {
        const err = await safeJson(res);
        throw new Error(err.message ?? err.error ?? "Anmeldung fehlgeschlagen");
    }
}
export async function signOut() {
    posthog.reset();
    await apiPost("/api/auth/sign-out", {});
}
export async function listGroups() {
    const data = await apiGet("/api/groups");
    return data.groups ?? [];
}
export async function activateGroup(groupId) {
    await apiPost("/api/groups/activate", { organizationId: groupId });
}
export async function getMyGroup() {
    try {
        return await apiGet("/api/groups/my-group");
    }
    catch {
        return null;
    }
}
export async function requestPasswordReset(email) {
    await apiPost("/api/auth/request-password-reset", { email });
}
export async function resetPassword(token, newPassword) {
    await apiPost("/api/auth/reset-password", { token, newPassword });
}
export async function updateUserName(name) {
    await apiPost("/api/auth/update-user", { name });
}
export async function changePassword(currentPassword, newPassword) {
    await apiPost("/api/auth/change-password", {
        currentPassword,
        newPassword,
        revokeOtherSessions: false,
    });
}
export async function getNotificationPreferences() {
    try {
        return await apiGet("/api/notifications/preferences");
    }
    catch {
        return { notifyOwnBuildings: true, notifyOthersBuildings: false };
    }
}
export async function updateNotificationPreferences(prefs) {
    await apiPatch("/api/notifications/preferences", prefs);
}
